import label from './yAxis.axisPointer.label'
import lineStyle from './yAxis.axisPointer.lineStyle'
import shadowStyle from './yAxis.axisPointer.shadowStyle'
import handle from './yAxis.axisPointer.handle'

export default {
  name: "axisPointer",
  nickname: "坐标轴指示器",
  desc: "axisPointer settings on axis.",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc:
        '默认不显示。但是如果 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.trigger">tooltip.trigger</a> 设置为 <code class="codespan">&#39;axis&#39;</code> 或者 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.axisPointer.type">tooltip.axisPointer.type</a> 设置为 <code class="codespan">&#39;cross&#39;</code>，则自动显示 axisPointer。坐标系会自动选择显示显示哪个轴的 axisPointer，也可以使用 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.axisPointer.axis">tooltip.axisPointer.axis</a> 改变这种选择。',
      value: false,
      defaultValue: false,
    },
    type: {
      name: "type",
      nickname: "类型",
      desc: "指示器类型。",
      value: "line",
      defaultValue: "line",
      type: "pureValue",
    },
    snap: {
      name: "snap",
      nickname: "snap",
      desc: "坐标轴指示器是否自动吸附到点上。默认自动判断。",
    },
    z: {
      name: "z",
      nickname: "z",
      desc:
        '坐标轴指示器的 z 值。控制图形的前后顺序。<code class="codespan">z</code>值小的图形会被<code class="codespan">z</code>值大的图形覆盖。',
    },
    label,
    lineStyle,
    shadowStyle,
    triggerTooltip: {
      name: "triggerTooltip",
      nickname: "是否触发提示",
      desc: "是否触发 tooltip。如果不想触发 tooltip 可以关掉。",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    value: {
      name: "value",
      nickname: "值",
      desc:
        '当前的 value。在使用 <a href="xAxisPointer.handle" target="_blank">axisPointer.handle</a> 时，可以设置此值进行初始值设定，从而决定 axisPointer 的初始位置。',
    },
    status: {
      name: "status",
      nickname: "状态",
      desc:
        '当前的状态，可取值为 <code class="codespan">&#39;show&#39;</code> 和 <code class="codespan">&#39;hide&#39;</code>。',
    },
    handle,
  },
}
